<template>
  <div id="app" ref="ttt">
    <!-- <img src="./assets/logo.png"> -->
    <router-view />
  </div>
</template>

<script>
    export default {
        name: "App",
        mounted() {
            // let height= document.documentElement.clientHeight || document.body.clientHeight ;
            // this.$refs.ttt.style.height = height + 'px';
            // console.log(height)
        }
    };
</script>

<style>
    #app {
        font-family: "Avenir", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        margin: 0;
        height: 100vh;
        width: 100%;
        font-family: SimHei;
        font-size: 13px;
    }
</style>


// WEBPACK FOOTER //
// src/App.vue